import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Your Net Income',
    type: t.VariableType.single,
    description: 'Your take home pay after all taxes and levies are deducted.',
    variable: 'Net_Income_1_Amt',
    frequency: 'Net_Income_1_Frequency',
    placeholder: '0.00'
  },
  {
    name: 'Your Partner / Spouses Net Income',
    type: t.VariableType.single,
    description: 'Your partner / spouses take home pay.',
    variable: 'Net_Income_2_Amt',
    frequency: 'Net_Income_2_Frequency',
    placeholder: '0.00'
  },
  {
    name: 'Child Benefit',
    type: t.VariableType.single,
    description: 'Universal monthly government payment for children up to 18 yrs old.',
    variable: 'Child_Benefit_Amt',
    frequency: 'Child_Benefit_Frequency',
    placeholder: '0.00'
  },
  {
    name: 'Social Welfare Payments',
    type: t.VariableType.single,
    description: 'Any other income your household earns after relevant taxes are deducted.',
    variable: 'Inc_Other_1_Amt',
    frequency: 'Inc_Other_1_Frequency',
    placeholder: '0.00'
  },
  {
    name: 'Other',
    type: t.VariableType.single,
    description: 'Any other income your household earns after relevant taxes are deducted.',
    variable: 'Inc_Other_2_Amt',
    frequency: 'Inc_Other_2_Frequency',
    placeholder: '0.00'
  },
]

const name = 'Income'
const title = 'Your Household Income'
// tslint:disable-next-line
const description = "When it comes to budgeting, the first thing you need to do, is understand what\'s actually coming into your household. Without being clear on that, its very difficult to know whether you're spending more than you have. Completing the below should reflect all the different incomes your household receives."
const outro = 'Next, we will look at what debt or any loans you might have'
const link = Routes.step1

const stepDefinition: t.StepDefinition = {
  index: 1,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
